// extracted by mini-css-extract-plugin
module.exports = {"PopUp":"GlobalPopup_PopUp__wRzSL","PopUpInner":"GlobalPopup_PopUpInner__14_5C","fade":"GlobalPopup_fade__3Q_cU"};